import { useEffect, useState } from "react";
import {
  type Toast,
  registerToastHandler,
  isToastLink,
  notificationProvider,
} from "@/lib/toasterLogic";

export { notificationProvider, isToastLink, type Toast };

export function Toaster() {
  const [toasts, setToasts] = useState<Toast[]>([]);
  useEffect(() => {
    registerToastHandler((t) => {
      setToasts((ts) => [...ts.filter((x) => x.key !== t.key), t]);
      setTimeout(() => setToasts((ts) => ts.filter((x) => x.key !== t.key)), 6000);
    });
    return () => { registerToastHandler(null); };
  }, []);
  if (toasts.length === 0) return null;
  return (
    <div className="fixed bottom-4 right-4 z-[90] flex flex-col gap-2 max-w-sm pointer-events-none">
      {toasts.map((t) => {
        const descStr = typeof t.description === "string" ? t.description.trim() : "";
        const isLink = isToastLink(descStr);
        return (
          <div key={t.key} role="status"
            className={`pointer-events-auto rounded-md border px-3.5 py-2.5 text-[13px] shadow-lg bg-card ${t.type === "error" ? "border-destructive text-destructive" : "border-border text-foreground"}`}>
            <div className="flex items-center justify-between gap-3">
              <div className="font-medium">{t.message}</div>
              {isLink && (
                <a
                  href={descStr}
                  onClick={(e) => {
                    if (descStr.startsWith("/")) {
                      const [path] = descStr.split("?");
                      if (window.location.pathname === path) {
                        e.preventDefault();
                        window.history.pushState({}, "", descStr);
                        window.dispatchEvent(new PopStateEvent("popstate"));
                      }
                    }
                  }}
                  className="px-2.5 py-1 text-xs font-semibold rounded bg-primary text-primary-foreground hover:bg-primary/90 shadow-sm transition-colors cursor-pointer inline-flex items-center gap-1 no-underline whitespace-nowrap shrink-0"
                >
                  View
                </a>
              )}
            </div>
            {t.description && !isLink && (
              <div className="mt-1 text-[12px] opacity-90">
                {t.description}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
